import { SxProps } from '@cp/ds';

export const CARD_CONTAINER_SX: SxProps = { borderRadius: '16px', flexDirection: 'column', overflow: 'hidden', position: 'relative' };
